import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { ProductPricingComponent } from './product-pricing.component';

@NgModule({
  imports: [CommonModule, I18nModule, TooltipIconModule, ProductPricingComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductPricingComponent: {
          component: ProductPricingComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ProductPricingComponent],
})
export class ProductPricingModule {}
